import { render, staticRenderFns } from "./ProductSync.vue?vue&type=template&id=57fdaaca&scoped=true"
import script from "./ProductSync.vue?vue&type=script&lang=js"
export * from "./ProductSync.vue?vue&type=script&lang=js"
import style0 from "./ProductSync.vue?vue&type=style&index=0&id=57fdaaca&prod&lang=scss"
import style1 from "./ProductSync.vue?vue&type=style&index=1&id=57fdaaca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fdaaca",
  null
  
)

export default component.exports